import useMobileView from '@/hooks/useMobileView';
import { useEffect, useRef, useState } from 'react';

const useSearchHeaderManager = (
  view: 'list' | 'map',
): {
  headerRef: React.RefObject<HTMLDivElement>;
  headerHeight: number | undefined;
} => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(undefined);
  const { isMobileView } = useMobileView();

  useEffect(() => {
    if (!headerRef.current) return;
    const { current } = headerRef;

    if (headerHeight && current.offsetHeight === headerHeight) {
      return;
    }

    setHeaderHeight(current.offsetHeight);
  }, [isMobileView, view]);

  return { headerRef, headerHeight };
};

export default useSearchHeaderManager;
